import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-button-group',
  templateUrl: './button-group.component.html',
  styleUrl: './button-group.component.scss',
})
export class ButtonGroupComponent {
  @Input() iconFillType?: 'filled' | 'outlined' | 'rounded';
  @Input() iconPosition?: 'Left' | 'Right' = 'Left';
  @Input() iconWidth?: string | number;
  @Input() iconHeight?: string | number;
  @Input() label?: string;
  @Input() icon?: string;
  @Input() buttonUseCase?: string = 'default';
  @Input() buttonType?: 'Primary' | 'Secondary' | 'Light' | 'TextButton';
  @Input() disabled?: boolean;
  @Input() cssClass?: string;
  @Input() color?: string;
  @Output() onEmit = new EventEmitter();

  handleClick(useCase: any): void {
    this.onEmit.emit(useCase);
  }
}
